import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const FormFieldsWrapperStyled = styled(Box)(({ theme }) => ({
  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
  overflowY: 'auto',
  paddingRight: '6px',
  margin: '9px 0 64px 0',

  [theme.breakpoints.down('lg')]: {
    overflowY: 'unset',
    paddingRight: 0,
    margin: '9px 0 0 0',
  },
}));

export const ContainerTopStyled = styled(Box)(({ theme }) => ({
  paddingBottom: '8px',
  borderBottom: '1px solid #d1d3d8',
  display: 'flex',
  flexWrap: 'wrap',
  '> *': {
    flex: '0 0 50%',
  },
  [theme.breakpoints.down('lg')]: {
    paddingLeft: '8px',
    paddingRight: '11px',
    '> *': {
      flex: '0 0 100%',
    },
  },
}));

export const ContainerBottomStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  '> *': {
    flex: '0 0 33.3333%',
  },
  [theme.breakpoints.down('lg')]: {
    paddingLeft: '8px',
    paddingRight: '11px',
    '> *': {
      flex: '0 0 50%',
    },
    marginBottom: '10px',
  },
}));

export const AdditionalInformationStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.colors.infoBackground,
  borderRadius: '5px',
  padding: '10px 10px 19px',
  marginTop: '10px',
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '10px',
  color: theme.palette.colors.mainFocused,
  marginRight: '4px',
  float: 'left',
}));

export const BalanceStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const CurrencyStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
